import React from 'react';
import './PortfolioItem.css';

function PortfolioItem({ item }) {
  const handleView = () => {
    // Open the HTML file in a new tab
    window.open(`/portfolio-files/${item.file}`, '_blank');
  };

  return (
    <div className="portfolio-item">
      <div className="portfolio-item-number">{String(item.id).padStart(2, '0')}</div>
      <h3 className="portfolio-item-title">{item.title}</h3>
      <p className="portfolio-item-description">{item.description}</p>
      <button onClick={handleView} className="portfolio-item-button">
        View Sample →
      </button>
    </div>
  );
}

export default PortfolioItem;

